<template>
  <div>
    <h2 v-if="Helper.is_dev()">DEV {{ URL_HEAD }}</h2>
    <h2>장비 리스트 - ⚠️ 순위 방식 조정 중입니다. 의견 주세요</h2>
    <div v-if="page.todos" class="m-4 flex">
      <div class="flex items-center text-3xl">진행율 {{ todos_percent }}</div>
      <div class="flex items-center ml-4">
        <span>처리중: {{ page.todos.todo }}</span>
        <span class="ml-4">완료: {{ page.todos.done }}</span>
      </div>
    </div>
    <div v-if="page.loading">불러오는중...</div>
    <div v-else-if="page.error">불러오기 실패했습니다. ({{ page.error }})</div>
    <div v-else class="text-lg font-bold">
      <div class="flex">
        <!-- <div>정렬<br />선택</div> -->
        <div class="ml-4">
          <button
            :class="classSort(SORT_HASH_WATT_PRICE)"
            @click="onSort(SORT_HASH_WATT_PRICE)"
          >
            <span v-if="IsSort(SORT_HASH_WATT_PRICE)">✔️</span>
            종합 <br />
            (성능 / 소비전력 / 가격)
          </button>
        </div>
        <div class="ml-4">
          <button
            :class="classSort(SORT_HASH_WATT)"
            @click="onSort(SORT_HASH_WATT)"
          >
            <span v-if="IsSort(SORT_HASH_WATT)">✔️</span>
            전성비 <br />
            (성능 / 소비전력)
          </button>
        </div>
        <div class="ml-4">
          <button
            :class="classSort(SORT_HASH_PRICE)"
            @click="onSort(SORT_HASH_PRICE)"
          >
            <span v-if="IsSort(SORT_HASH_PRICE)">✔️</span>
            가성비 <br />
            (성능 / 가격)
          </button>
        </div>
        <!-- <div class="ml-4">
          {{ page.sort_desc }}
        </div> -->
      </div>

      <div v-for="data in page.list" :key="data.uid">
        <div class="m-2 p-2 border-2 flex-none md:flex md:justify-around">
          <!-- <div>{{ data.uid }}</div> -->
          <!-- <div class="w-full md:w-12">
            {{ data.rank }}. {{ data.rank_point }}점
          </div> -->
          <div class="w-full md:w-12">
            <span class="block md:hidden">
              {{ "순위: " + data.rank }}
            </span>
            <span class="hidden md:block"> {{ data.rank }}. </span>
          </div>
          <div class="w-full md:w-40">
            <span class="block md:hidden">
              {{ "제품명: " + data.name }}
            </span>
            <span class="hidden md:block"> {{ data.name }}</span>
          </div>
          <div class="w-full md:w-12">
            <span class="block md:hidden">
              {{ "점수: " + num_comma(data.rank_point) }}
              <span class="tw_unit"></span>
            </span>
            <span class="hidden md:block">
              {{ num_comma(data.rank_point) }}
              <br />
              <span class="tw_unit">점수</span>
            </span>
          </div>
          <div class="w-full md:w-12">
            <span class="block md:hidden">
              {{ "성능: " + data.hashrate }}
              <span class="tw_unit">TH/s</span>
            </span>
            <span class="hidden md:block">
              {{ data.hashrate }} <br />
              <span class="tw_unit">TH/s</span>
            </span>
          </div>
          <div class="w-full md:w-12">
            <span class="block md:hidden">
              {{ "소비전력: " + data.watt }}
              <span class="tw_unit">W/h</span>
            </span>
            <span class="hidden md:block">
              {{ data.watt }}<br />
              <span class="tw_unit">W/h</span>
            </span>
          </div>
          <div class="w-full md:w-12">
            <span class="black md:hidden">
              {{ "가격: " + num_comma(data.price / 10000, 1) }}
              <span class="tw_unit">만원</span>
            </span>
            <span class="hidden md:block">
              {{ num_comma(data.price / 10000, 1) }} <br />
              <span class="tw_unit">만원</span>
            </span>
          </div>
          <div class="w-full md:w-12">
            <button @click="onReportGo(data)">
              <div class="text-sm">의견쓰기</div>
            </button>
          </div>
        </div>
        <div v-if="Helper.is_dev()">DEV: 계산식 {{ data.temp }}</div>
      </div>

      <!-- 의견 입력란 -->
      <div class="mt-16">
        <h3>의견 전송</h3>
        <div class="m-4">
          <div v-if="page.report_item">
            {{ page.report_item.name }}
          </div>
          <div class="w-full">
            <div class="w-128">
              <textarea
                ref="ui_report_input"
                v-model="page.report_input"
                type="text"
                placeholder="내용 입력해주세요..."
                :class="textarea_class"
              />
            </div>
          </div>
          <div>
            <button @click="onReportSend">전송하기</button>
            <span class="ml-4">{{ page.report_error }}</span>
          </div>
        </div>
      </div>

      <!-- 장비 리스트 마지막 광고 추가 
      <div>
        <Adsense
          adStyle="display:block"
          format="fluid"
          layoutKey="-fb+5w+4e-db+86"
          clientId="ca-pub-4928043623873125"
          slotId="4852920125"
        >
        </Adsense>
      </div>
      -->
    </div>
    <!-- <div class="mt-4 text-xs">
      표시되는 정보는 읽기 쉽도록 줄여 표시한 것입니다. <br />
      정확한 수치는 아닙니다.
    </div> -->
  </div>
</template>

<script lang="ts" setup>
// src\views\HomeView.vue
import { useStore } from "vuex";
// import { useRoute, useRouter } from "vue-router";
import * as Vue from "vue";
// import { Icon } from "@iconify/vue";
// import { VERSION, BUILD_DATE } from "@/ver";
// import moment from "moment";
// import im2 from "@/components/Img2.vue";
import * as Helper from "@/helper";
import * as Types from "@/types";
// import { Adsense } from "vue3-google-adsense";
import * as Use from "@vueuse/core";

const URL_HEAD = Types.get_url_head();

// const route = useRoute();
// const router = useRouter();
const store = useStore();
const is_dark = Use.useDark();

interface TODOS {
  todo: number;
  done: number;
}

interface PAGE {
  loading: boolean;
  error: string;
  list: Types.T_DEVICE[];
  sort_v: number;
  sort_desc: string;
  //
  report_use: boolean;
  report_item: Types.T_DEVICE | null;
  report_input: string;
  report_error: string;
  //
  todos: undefined | TODOS;
}

const ui_report_input = Vue.ref<HTMLInputElement | null>(null);
const page = Vue.ref<PAGE>({
  loading: true,
  error: "",
  list: [] as Types.T_DEVICE[],
  sort_v: 0,
  sort_desc: "",
  //
  report_use: false,
  report_item: null,
  report_input: "",
  report_error: "",
});

// const device_sort_v = Vue.ref(0);
// const device_list_wait = Vue.ref(true);
// const device_list_error = Vue.ref(false);
// const device_list = Vue.ref<Types.T_DEVICE[]>([]);

const SORT_HASH_WATT_PRICE = 0;
const SORT_HASH_WATT = 1;
const SORT_HASH_PRICE = 2;
// const sort_desc = Vue.ref("");

// 3 자리 마다 콤마, 소수점 없음음
const num_comma = (n: number | undefined, point: number = 0) => {
  if (n === undefined) {
    return "?";
  }

  var str = n.toLocaleString("ko-KR");
  var full = str;

  // 소수점 자르기 작업
  var pos = str.indexOf(".");
  if (pos <= 0) return str;

  if (point == 0) {
    return str.substring(0, pos);
  }

  pos += 1;
  var left = str.length - pos;
  // console.log("num_comma", full, point, left);
  if (point >= left) return str;

  return str.substring(0, pos + point);
};

//
const todos_percent = Vue.computed(() => {
  if (page.value.todos === undefined) return "--%";

  var a = page.value.todos.todo;
  if (a === undefined) a = 0;
  var b = page.value.todos.done;
  if (b === undefined) b = 0;

  var c = (b / (a + b)) * 100;
  c = Math.round(c);
  // console.log("todos_percent", a, b, c);

  return `${c}%`;
});

//
const textarea_class = Vue.computed(() => {
  console.log("textarea_class", is_dark.value);
  if (is_dark.value) {
    return "tw_textarea_dark";
  }
  return "tw_textarea";
});

Vue.onMounted(async () => {
  console.log("proc_mount start");
  page.value.loading = true;
  page.value.error = "";
  page.value.list = [];
  // device_list_wait.value = true;

  try {
    const url = URL_HEAD + "/bitaxe/all_device";
    const res = await Helper.web_get(url);
    // console.log("res", url, res.data);

    // device_list_wait.value = false;
    if (res.data.code != 200) {
      console.error("res.data fail", res.data);
      // device_list_error.value = true;

      page.value.loading = false;
      page.value.error = "loading_fail";
      return;
    }

    console.log("res ok", res.data);

    const list = res.data.list as Types.T_DEVICE[];
    // for (var i in list) {
    //   const v = list[i];
    //   v.hash_watt = v.hashrate / v.watt;
    //   v.hash_watt_price = v.hash_watt / v.price;
    // }
    page.value.list = list;
    onSort(SORT_HASH_WATT_PRICE);

    // 개발용 데이터
    if (Helper.is_dev()) {
      page.value.todos = {
        todo: 10,
        done: 10,
      };
    }

    // todos 정보가 있다.
    if (res.data.todos !== undefined) {
      page.value.todos = res.data.todos as TODOS;
    }

    // console.log("store.state.count", store.state.count);
    store.commit("device_list", list);
  } catch (err) {
    const e = err as Error;
    console.error("req fail", e.message);
    // device_list_wait.value = false;
    // device_list_error.value = true;

    page.value.error = "loading fail";
  }

  page.value.loading = false;
});

function onSort(v: number) {
  console.log("onSort", v);

  var list = page.value.list;
  page.value.sort_v = v;

  if (v == SORT_HASH_WATT_PRICE) {
    console.log("sort SORT_HASH_WATT_PRICE");

    page.value.sort_desc = "성능 & 소비전력 & 가격을 종합한 순위 입니다.";

    // 기준 점수
    const r_hash = 100;
    const r_watt = 0.5;
    const r_price = 10000;
    for (const data of list) {
      var price = data.price / r_price;
      var per_hash = (data.hashrate / price) * r_hash;
      var per_watt = (data.watt / price) * r_watt;
      var total = per_hash;
      total += per_watt;
      total *= 1000;
      data.rank_point = total;
      data.temp = `${per_hash.toFixed(3)} / ${per_watt.toFixed(3)}`;
    }

    // rank_point 가 높은 순으로
    list = list.sort((a, b) => {
      const val_1 = a.rank_point as number;
      const val_2 = b.rank_point as number;
      if (val_1 > val_2) return -1;
      if (val_1 < val_2) return 1;
      return 0;
    });
  } else if (v == SORT_HASH_WATT) {
    console.log("sort SORT_HASH_WATT");
    page.value.sort_desc = "성능과 전력소비 만 고려한 순위입니다. (가격 제외)";

    // 기준 점수
    for (const data of list) {
      data.rank_point = data.hashrate / data.watt;
      data.rank_point *= 1_000_0;
    }

    // rank_point 가 높은 순으로
    list = list.sort((a, b) => {
      const val_1 = a.rank_point as number;
      const val_2 = b.rank_point as number;
      if (val_1 > val_2) return -1;
      if (val_1 < val_2) return 1;
      return 0;
      // // 해시 높은 순
      // if (a.hashrate > b.hashrate) return -1;
      // if (a.hashrate < b.hashrate) return 1;
      // return 0;
    });
  } else if (v == SORT_HASH_PRICE) {
    console.log("sort SORT_HASH_PRICE");
    page.value.sort_desc = "성능과 가격 만 고려한 순위입니다. (소비전력 제외)";

    // 기준 점수
    for (const data of list) {
      data.rank_point = data.hashrate / data.price;
      data.rank_point *= 10_000_000;
    }

    // rank_point 가 높은 순으로
    list = list.sort((a, b) => {
      const val_1 = a.rank_point as number;
      const val_2 = b.rank_point as number;
      if (val_1 > val_2) return -1;
      if (val_1 < val_2) return 1;
      return 0;
      // // 해시 높은 순
      // if (a.hashrate > b.hashrate) return -1;
      // if (a.hashrate < b.hashrate) return 1;
      // return 0;
    });
  }

  console.log("list", list);

  // // 최고전수
  // var max_point = 0;
  // for (const data of list) {
  //   const n = data.rank_point as number;
  //   if (n < max_point) continue;
  //   max_point = n;
  // }

  // // 환
  // for (const data of list) {
  //   const n = data.rank_point as number;
  //   // data.rank_point = Math.round((n / max_point) * 100);
  //   data.rank_point = Math.round(n * 10000);
  // }

  let rank = 0;
  list.forEach((r) => {
    rank++;
    r.rank = rank;
  });
  console.log("onSort", v, list);
  // device_list.value = list;
  // device_sort_v.value = v;
  page.value.list = list;
}

// const onDetail = (uid: number) => {
//   console.log("onDetail", uid);
//   router.push("/detail/" + uid);
// };

// 선택되었나?
const IsSort = (v: number) => {
  return v == page.value.sort_v;
};

// 표시할 class
const classSort = (v: number) => {
  // return v == device_sort_v.value ? "sort_on" : "sort_off";
  return v == page.value.sort_v ? "sort_on" : "sort_off";
};

// 제보하러가기기
const onReportGo = (data: Types.T_DEVICE) => {
  console.log("onReport", data);

  page.value.report_use = true;
  page.value.report_item = data;
  page.value.report_input = "";
  if (ui_report_input.value == null) {
    console.log("ui is null");
  } else {
    // console.log("ui is good");
    ui_report_input.value.focus();
  }
};

// 제보 전송
const onReportSend = async () => {
  var val = page.value;
  console.log("onReportSend start", val.report_item, val.report_input);

  // 전송하기
  val.report_error = "전송중";

  let device_uid = 0;
  let content = "---\n" + val.report_input;
  if (val.report_item) {
    device_uid = val.report_item.uid;
    content = val.report_item.name + "\n" + content;
  }

  try {
    const url = URL_HEAD + "/bitaxe/report_write";
    const res = await Helper.web_post(url, {
      body: {
        device_uid,
        content,
      },
    });

    const data = res.data;
    console.log("data", data);

    if (data.code != 200) {
      throw new Error("code fail, " + data.code);
    }

    // page.value.report_use = false;
    val.report_item = null;
    val.report_input = "";
    val.report_error = "✔️ 전송 완료";
  } catch (err) {
    const e = err as Error;
    console.error("req fail", e.message);
    val.report_error = "❌ 전송 실패, " + e.message;
  }
};
</script>

<style scope>
.sort_on {
  @apply font-bold text-xl border-none;
}
.sort_off {
  @apply font-normal text-lg border-2;
}

.tw_textarea {
  @apply w-full px-5 py-3 rounded-2xl
   bg-gray-100 
   border border-gray-100 
   shadow-[inset_2px_2px_5px_rgba(0,0,0,0.05),5px_5px_10px_rgba(0,0,0,0.02)] 
   focus:outline-none focus:bg-gray-100 focus:shadow-[0_0_0_2px_rgba(59,130,246,0.1),8px_8px_20px_rgba(0,0,0,0.05)] 
   transition-all duration-300;
}
.tw_textarea_dark {
  @apply w-full px-5 py-3 rounded-2xl
   bg-gray-800 
   border border-gray-600 
   shadow-[inset_2px_2px_5px_rgba(0,0,0,0.05),5px_5px_10px_rgba(0,0,0,0.02)] 
   focus:outline-none focus:bg-gray-800 
   focus:shadow-[0_0_0_2px_rgba(59,130,246,0.1),8px_8px_20px_rgba(0,0,0,0.05)] 
   transition-all duration-300;
}
</style>
